import { render, staticRenderFns } from "./FCDropzone.vue?vue&type=template&id=406eb8ce&scoped=true&"
import script from "./FCDropzone.vue?vue&type=script&lang=js&"
export * from "./FCDropzone.vue?vue&type=script&lang=js&"
import style0 from "./FCDropzone.vue?vue&type=style&index=0&id=406eb8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406eb8ce",
  null
  
)

export default component.exports